import React from "react";
import StaticCardActionBtn from "../components/StaticCardActionBtn";

export default function GetStaticCardAction(answer) {
  switch (answer) {
    case 1:
      return <StaticCardActionBtn type="positive" />;
    case 2:
      return <StaticCardActionBtn type="neutral" />;
    case 3:
      return <StaticCardActionBtn type="negative" />;
    default:
      return "";
  }
}
